import { render, staticRenderFns } from "./SetupOverview.vue?vue&type=template&id=363e089d&scoped=true"
import script from "./SetupOverview.vue?vue&type=script&lang=ts"
export * from "./SetupOverview.vue?vue&type=script&lang=ts"
import style0 from "./SetupOverview.vue?vue&type=style&index=0&id=363e089d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363e089d",
  null
  
)

export default component.exports